import { createColumnHelper } from '@tanstack/react-table'
import { formatDate } from '../../../../../../utils/tableFuncs'
import type { Invoice } from '../../../../../../types'
import { getConsolidateInvoiceDescription } from '../../../../../../utils/getConsolidateInvoiceDescription'

type InvoiceReportColumnsOptions = {
  chosenCompany?: string
}

export default function invoiceReportColumns({ chosenCompany }: InvoiceReportColumnsOptions) {
  const columnHelper = createColumnHelper<Invoice>()
  return [
    columnHelper.accessor('consolidatedInvoiceNo', {
      id: 'consolidatedInvoiceNo',
      header: () => 'Fakturanr',
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('consolidatedInvoiceCode', {
      id: 'consolidatedInvoiceCode',
      header: () => 'Samlefaktura',
      enableSorting: false,
      cell: (row) => getConsolidateInvoiceDescription(row.getValue(), chosenCompany) || '',
    }),
    columnHelper.accessor('postingDate', {
      id: 'postingDate',
      header: () => 'Fakturadato',
      cell: (row) => formatDate(row.getValue()) || '',
    }),
    columnHelper.accessor('consolidatedInvoiceDescription', {
      id: 'consolidatedInvoiceDescription',
      header: () => 'Beskrivelse',
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('billToCustomerName', {
      id: 'billToCustomerName',
      header: () => 'Fakturamottaker',
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
  ]
}
